import { Route } from '@angular/router';
import { CreateTenderSuppliersComponent } from '../../../../pages';
import { TenderStepGuard } from '../../../guards';
import {
    SuppliersResolver,
    SuppliersTabsResolver,
    TenderInvitedSupplierUsersResolver
} from '../../../resolvers';

export const createTenderSuppliersRoute: Route = {
    path: 'suppliers',
    component: CreateTenderSuppliersComponent,
    canActivate: [TenderStepGuard],
    resolve: {
        suppliers: SuppliersResolver,
        availableTabs: SuppliersTabsResolver,
        //tenderSuppliers: TenderSuppliersResolver,
        tenderInvitedSupplierUsers: TenderInvitedSupplierUsersResolver
    },
    children: [
        {
            path: ':supplierId/edit',
            component: CreateTenderSuppliersComponent
        }
    ]
};
